module.exports = __webpack_public_path__ + "site/img/54.637ee840.jpg";